jQuery(window).load(function(){
        if (window.location.hash && window.location.hash != '#designers') {
            var hash = window.location.hash.split('#');
            setTimeout(function(){
            	if(typeof hash[1] !== "undefined" && hash[1].indexOf("/") == -1) {
	                if (hash.length > 1 && jQuery('#' + hash[1]).length > 0) {
	                    var top = 0;
	                    jQuery('#' + hash[1]).parents('.row').each(function(){
	                        top += jQuery(this).position().top;
	                    });
	                    jQuery('html, body').stop().animate({
	                        scrollTop: top
	                    }, 500)
	                }
	            }
            }, 400)
        }
        //jQuery('.homepage-new-template .slick-slider-stage').slickPlay();
        jQuery('.before-after-landing-page .ba-sections').removeClass('hideContent');
    })
    .resize(function(){
        if (jQuery(window).width() < 768) {
            if (jQuery('.lower-nav').height() > 0 && jQuery('.lower-nav').height() != jQuery(window).height() - jQuery('.mobile-header').height()) {
                jQuery('.lower-nav').css('height', jQuery(window).height() - jQuery('.mobile-header').height());
            }
        }else{
            jQuery('.lower-nav').css('height', "");
        }
    })
    .error(function(){
        //console.log('ba-section error fallback');
        setTimeout(function(){
            jQuery('.before-after-landing-page .ba-sections').removeClass('hideContent');
            jQuery('.homepage-new-template .ba-sections').removeClass('hideContent');

            if(jQuery('.homepage-new-template .slick-slider-stage').length>0){
            	jQuery('.homepage-new-template .slick-slider-stage').slick('slickPlay');
        	}
        }, 5000)
    });

$(window).load(function(){
    // topten readmoreless
   // moreLess();

    //locations tabbed room read more less
    tabbedContentMoreLess();
    mobileTabbedContent();

    //twentytwenty init
    if( $(".twentytwenty-container").length ) {
        $(".twentytwenty-container").twentytwenty();
    }

});
$(window).resize(function(){
   // rfMobile();
   // resizeTeamPopupHeight();

    $('.ba-galleries .connected-carousels .slick-slider-stage').find("[data-slick-index='0'] .twentytwenty-container").each(function(){
        $(this).find('.twentytwenty-overlay').each(function(){
            $(this).remove();
        });
        $(this).find('.twentytwenty-handle').each(function(){
            $(this).remove();
        });
        $(this).twentytwenty();
    });
});


/* =========================================================
    Set max content limit 
    ============================================================ */

function equalHeight(){
	
	
	/* =========================================================
    Equal Height for home page
    ============================================================ */
	
	var ourProcess = $(".OurProcessCustomCrafte .card-text-pad");
	// var vacouverActivity = $(".vacouver-activity .card-text-pad");
	var ccCanadaintaller = $(".cc-canada_3dinstaller .card-text-pad");
	
	var globalHeight = $(ourProcess).map(function ()

		{
			return $(this).height();
		}).get(),
		
		maxHeight = Math.max.apply(null, globalHeight);
		$(ourProcess).css('min-height', maxHeight+'px');
	
	
	/* =========================================================
    Equal Height for home page
    ============================================================ */
	
	/*count height*/		
		// var globalHeight = $(vacouverActivity).map(function ()
        //
		// {
		// 	return $(this).height();
		// }).get(),
		//
		// maxHeight = Math.max.apply(null, globalHeight);
		// $(vacouverActivity).css('min-height', maxHeight+'px');
		
	/*count height end*/	
	
	
	/*count height*/		
		var globalHeight = $(ccCanadaintaller).map(function ()

		{
			return $(this).height();
		}).get(),
		
		maxHeight = Math.max.apply(null, globalHeight);
		$(ccCanadaintaller).css('min-height', maxHeight+'px');
		
	/*count height end*/
	
	
	/*count height*/		
		var heights = $(".cc-canada_pointsdiff .card-text-pad").map(function ()

		{
			return $(this).height();
		}).get(),

		maxHeight = Math.max.apply(null, heights);
		$('.cc-canada_pointsdiff .card-text-pad').css('min-height', maxHeight+'px');
		
	/*count height end*/	
	
	/*count height*/		
		var heights = $(".address-parts").map(function ()

		{
			return $(this).height();
		}).get(),

		maxHeight = Math.max.apply(null, heights);
		$('.address-parts').css('min-height', maxHeight+'px');
		
	/*count height end*/
	
	/*count height*/
		var heights = $(".fr .foot-first").map(function ()

		{
			return $(this).height();
		}).get(),

		maxHeight = Math.max.apply(null, heights);
		$('.fr .foot-first').css('min-height', maxHeight+'px');
		
	/*count height end*/
	
	/*count height*/		
	if ($(window).width() >= 768) {	
		var heights = $(".crafts-boxes .card-text-pad").map(function ()

		{
			return $(this).height();
		}).get(),

		maxHeight = Math.max.apply(null, heights);
		$('.crafts-boxes .card-text-pad').css('min-height', maxHeight+'px');		
	} else{
		$('.crafts-boxes .card-text-pad').css('min-height', '');	
	}
		
	/*count height end*/
	
	/*count height*/		
		var heights = $(".fr .eql-height").map(function ()

		{
			return $(this).height();
		}).get(),

		maxHeight = Math.max.apply(null, heights);
		$('.fr .eql-height').css('min-height', maxHeight+'px');
		
	/*count height end*/
	
	/*count height*/		
		var heights = $(".team-member .main-section").map(function ()

		{
			return $(this).height();
		}).get(),

		maxHeight = Math.max.apply(null, heights);
		$('.team-member .main-section').css('min-height', maxHeight+'px');

	/*count height end*/

	/*count height*/
		var heights = $(".address-nav h5, .address-nav .h5").map(function ()

		{
			return $(this).height();
		}).get(),

		maxHeight = Math.max.apply(null, heights);
		$('.address-nav h5, .address-nav .h5').css('min-height', maxHeight+'px');

	/*count height end*/

	/*count height*/
		var heights = $(".expert-content").map(function ()

		{
			return $(this).height();
		}).get(),

		maxHeight = Math.max.apply(null, heights);
		$('.expert-content').css('min-height', maxHeight+'px');
		
	/*count height end*/
	
}

function galleryHeight(){
	/*count height*/		
		var heights = $(".single-designer-gallery .vancouver-designs").map(function ()

		{
			return $(this).height();
		}).get(),

		maxHeight = Math.max.apply(null, heights);
		$('.single-designer-gallery .vancouver-designs').css('min-height', maxHeight+'px');
		
	/*count height end*/
	
}

function dtybHeight(){
	/*count height of dtyb*/	
		
		if ($(window).width() > 769) {		
			var heights = $(".DTYB .widget_rightimg").map(function ()	

			{
				return $(this).height();
			
			}).get(),		
		

			maxHeight = Math.max.apply(null, heights);
			$('.DTYB .widget_content_outer').css('min-height', maxHeight+'px');	
		}else{
			$('.DTYB .widget_content_outer').css('min-height', '');	
		}
		
	/*count height of dtyb end*/	
	
}


$(window).ready(function() {
	equalHeight();
	galleryHeight();
	//imageZoom();	
	$(".sbi_load_btn .sbi_btn_text").text("Load more");
	$(".fr .sbi_load_btn .sbi_btn_text").text("Télécharger plus");
	$(".walk-in-sections-part").load();

    //scrollup
    $.scrollUp({
        scrollName: 'scrollUp',
        topDistance: '300',
        topSpeed: 300,
        animation: 'fade',
        animationInSpeed: 200,
        animationOutSpeed: 200,
        scrollText: '<span class="fa fa-arrow-up"><span class="sr-only">Scroll up</span></span>',
        activeOverlay: false,
    });
})

$(window).load(function() {
	equalHeight();	
	dtybHeight();
	$(".walk-in-sections-part").load();	
})

$(window).resize(function() {
	equalHeight();
	galleryHeight();
	dtybHeight();
})


$( document ).ready(function() {

	/*for single slider with dots*/
	$('.single-slider').owlCarousel({
		loop:true,
		margin:10,
		responsiveClass:true,
		items:1,
		autoplay:true,
		autoplayTimeout:6000,
		smartSpeed:1000,
		mouseDrag: false
	});
	
	$('.about-slider').owlCarousel({
		loop:true,
		margin:10,
		responsiveClass:true,
		items:1,
        autoplay:true,
		nav:true,
        dots:false,
		mouseDrag: false,
		touchDrag: false,
		autoplayTimeout:3000
	});
	
	/*for single slider with dots end*/
	
	/*for single slider with nav arrow*/
	$('.sliderWD-nav').owlCarousel({
		loop:true,
		margin:10,
		responsiveClass:true,
		items:1,
        autoplay:false,
		nav:true,
        dots:false,
		mouseDrag: false,
		touchDrag: false,
		autoplayTimeout:3000
	});
	
	/*for single slider with nav arrow end*/
	
	
    /*for single slider with dots and nav */
    $('.before-after-carousel').owlCarousel({
        loop:true,
        margin:10,
        responsiveClass:true,
        items:1,
        nav:true,
        autoplay:true,
		smartSpeed:1500,
		autoplayTimeout:6000,
		mouseDrag: false
    });
    
    /*for single slider with dots end*/

	/*click to slide search*/
		$('.mobile-menu-search .open-search').click(function(){
		if ($(window).width() > 767) {
			$(".mobile-menu-search .searchbox-input").animate({
				'opacity': '1', 'width': '170'
			}, 100, function(){
				$('.searchbox-input').css({'border': '1px solid #999999', 'padding-right': '5px'});
				$('.open-search').hide(100);
				$('html').click(function(){
						
			 if ($('body').hasClass('fr')) {
				 $('.mobile-menu-search .searchbox-input').css({'width': '70'}, 100);
			   }
				else{
					$('.mobile-menu-search .searchbox-input').css({'width': '44'}, 100);
				}	
					setTimeout(function(){ $('.searchbox-input').css({'border': '1px solid #fff', 'padding-right': '0'}), 500});
					$('.open-search').show(100);
				});
				$('.mobile-menu-search').click(function(event){
					event.stopPropagation();
				});
			}).show();
		}
	});
	/*click to slide search end*/

	$('.slider-client').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		autoplay: true,
		centerMode: false,
		centerPadding: '10px'
		});
	
	  /*   $('.slider-client').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: initialSlide,
        centerMode: false,
        adaptiveHeight: false,
        draggable: draggableOption,
        swipe: draggableOption,
        arrows: true,
        autoplay: true,
        autoplaySpeed: autoplaySpeedOption,
        prevArrow: '<a href="javascript:void(0)" class="slick-prev"><span></span></a>',
        nextArrow: '<a href="javascript:void(0)" class="slick-next"><span></span></a>',
    }); */

	

    /*Only for detail page slider*/

    //var galid = $(".storage-wrapper .slider").attr('id');

    $(".storage-wrapper .slider").each(function(element, index) {
        var galid = $(this).attr("id"); //alert(galid);

        if(galid!=='undefined'){

            $('.slider-for-'+galid).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                centerMode: true,
                fade: true,
                asNavFor: '.slider-nav-'+galid
            });
            $('.slider-nav-'+galid).slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              asNavFor: '.slider-for-'+galid,
              dots: false,
            
              focusOnSelect: true,
              responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true
                      }
                    },
					
					{
                      breakpoint: 767,
                      settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                      }
                    },
					
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                      }
                    }
                  ]
            });
        }
    });
	
	



    /*SICK SLIDER AND GALLERY STARTS HERE*/

    if($('.slider-for').length > 0) {

    	var pid = $("span#pid").html();

        //check pid is numeric
        if ($.isNumeric(pid) === true) {
            pid = (pid === '0' ?  pid = 0 : pid -1);
        }
        else {
            pid = 0;
        }

        $('.slider-for').slick({
			initialSlide: pid,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			centerMode: true,
			fade: true,
			/* 	  adaptiveHeight: true, */
			asNavFor: '.slider-nav'
        });
        
        $('.slider-nav').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: '.slider-for',
          dots: false,
        
          focusOnSelect: true,
		  responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true
				  }
				},
				{
				  breakpoint: 600,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				  }
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			  ]
        });

        $('.slider-for-right').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: true,
          asNavFor: '.slider-nav-right'
        });
        
        $('.slider-nav-right').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
           dots: false,
          asNavFor: '.slider-for-right',
          dots: false,
          centerMode: true,
          focusOnSelect: true
        });
    }
    /*SICK SLIDER AND GALLERY ENDS HERE*/
	
if ($(window).width() > 767) {
/*mega dropdown*/
var $menu = $(".dropdown-menu");

        // jQuery-menu-aim: <meaningful part of the example>
        // Hook up events to be fired on menu row activation.
        $menu.menuAim({
            activate: activateSubmenu,
            deactivate: deactivateSubmenu
        });
        // jQuery-menu-aim: </meaningful part of the example>

        // jQuery-menu-aim: the following JS is used to show and hide the submenu
        // contents. Again, this can be done in any number of ways. jQuery-menu-aim
        // doesn't care how you do this, it just fires the activate and deactivate
        // events at the right times so you know when to show and hide your submenus.
        function activateSubmenu(row) {
            var $row = $(row),
                submenuId = $row.data("submenuId"),
                $submenu = $("#" + submenuId),
                height = $menu.outerHeight(),
                width = $menu.outerWidth();

            // Show the submenu
            $submenu.css({
                display: "block",
                //top: -1,
                //left: width - 3,  // main should overlay submenu
                //height: height - 4  // padding for main dropdown's arrow
            });

            // Keep the currently activated row's highlighted look
            $row.find("a").addClass("current-active");
        }

        function deactivateSubmenu(row) {
            var $row = $(row),
                submenuId = $row.data("submenuId"),
                $submenu = $("#" + submenuId);

            // Hide the submenu and remove the row's highlighted look
            $submenu.css("display", "none");
            $row.find("a").removeClass("maintainHover");
			
        }
		
			$('.dropdown-menu').mouseleave(function(){
				$('.navigation ul.dropdown-menu > li:first-child a').addClass("maintainHover");
			});
			


        $(document).click(function() {
            // Simply hide the submenu on any click. Again, this is just a hacked
            // together menu/submenu structure to show the use of jQuery-menu-aim.
            $(".popover").css("display", "block");
            $("a.maintainHover").addClass("maintainHover");
        });	
};	   
        $('.show-book-now').on('click', function(es){
            es.preventDefault();
            if($('#hp_slide_book_now').length > 0) {
                if($('#hp_slide_book_now').is(":visible") == true) {
                    $('#hp_slide_book_now').fadeOut(150, function() {
                        $("#top_button_book_now").fadeIn(150);
                    });
                }
                else {
                    $("#top_button_book_now").fadeOut(150, function() {
                        $("#hp_slide_book_now").fadeIn(150);
                    });
                }
            }
            else {
                if($('#top_button_book_now').is(":visible") == true) {
                    $("#top_button_book_now").fadeOut(150);
                }
                else {
                    $("#top_button_book_now").fadeIn(150);
                }
            }
        });
        
		//Count height and add padding

		function headerInner(){
		  //padding for top header  
		  var headerHeight = jQuery('header').height();
		  var adminBar = jQuery('#wpadminbar').length;
		  // If the admin bar is present subtract its height.
		  var SitePaddTop = adminBar ? headerHeight - 32 : headerHeight;
		  jQuery('body').css('padding-top', SitePaddTop+'px');
		  
		 }
		 
		 
		 jQuery(window).load(function() {
			 headerInner();			 
		 });
		 
		 jQuery(window).resize(function() {
			headerInner();
		 });
		 
		 jQuery(document).ready(function() {
			headerInner();
		 });
    
	/* member modal load js - starts here */
    $('.member-readmore .read-more').on('click', function(){
        $(".team-member-modal .modal-body").html(' ');
        
        var ajaxdata = 'member_id=' + $(this).attr('rel') + "&action=load_member_modal&type=member";
        $.post(ajaxurl, ajaxdata, function(res){
            if ('$(window).width() > 767') {
                let window_h = $(window).height();
                let modalMarginTop = parseInt($("#team-member-modal .modal-dialog").css("marginTop"));
                let modalMarginBottom = parseInt($("#team-member-modal .modal-dialog").css("marginBottom"));
                if (window_h > ( modalMarginTop + modalMarginBottom)) {
                    $('#team-member-modal .modal-dialog').height(window_h - modalMarginTop - modalMarginBottom);
                }
                $(".team-member-modal .modal-body").html(res);
                $("#team-member-modal").modal('show');
                $(".team-member-modal .modal-body .modal-content").css('overflow', 'auto');
            }
        });
    });
    $(document).on("touchstart", '.modal', function(e){
        if ($('body').hasClass('modal-open')) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            return e.false;
        }
    });
    $('.member_responsive .team-read-more').on('click', function(e){
        e.preventDefault();
        $(this).fadeOut();
        $(this).parent().find('.expanded-text').each(function(){
            $(this).fadeIn();
        });
    });
    $('.member_responsive .team-read-less').on('click', function(e){
        e.preventDefault();
        $(this).parent().fadeOut();
        $('a.team-read-more').fadeIn();
    });
    
    /******* Client story page - Room Selection *********/
    
    $('.room_filter_client_stories').on( 'change', function(){
        var RoomTypeId = $(this).val();
        var term_id = $('#term_id').val();
        var ajaxdata = "roomId=" + RoomTypeId + "&termId="+term_id+"&action=filter_client_stories";
        $('.filter-loader').show();
        $.post(ajaxurl, ajaxdata, function (res) {
            $("#storyData").html(res);
            $('.filter-loader').hide();
        });
        return false;
    });
    //clientStoryCarousel();
    //subroomCarousel()

    /*$('.btn-wrapper a.read-more').on('click', function(e){
        e.preventDefault();
        $(this).hide();
        $('#aboutus_more').fadeIn();
    });
    $('.btn-wrapper a.slide-less').on('click', function(e){
        e.preventDefault();
        $('.btn-wrapper a.read-more').show();
        $('#aboutus_more').slideUp();
        $('.slide-more').fadeIn();
        $('html, body').animate({
            scrollTop: $('.step_section').position().top
        }, 400);
    });*/

    $('.btn-wrapper a.read-more').on('click', function(e){
        e.preventDefault();
        $(this).hide();
        $('#aboutus_more').fadeIn();
    });
    $('.btn-wrapper a.slide-less').on('click', function(e){
        e.preventDefault();
        $("#aboutus_more").slideUp();
        $('a.read-more').fadeIn();
        $('html, body').animate({
            scrollTop: $('.about-page-txt').position().top
        }, 400);
    });


    /* sign Up button js - starts here */
    //$('.signup-form button').on('click', function(){
    $('input#contact-submit').on('click', function(){
        var btn = $(this);
        $('.signup-form p.error-message').remove();
        btn.prop("disabled", true);
        var ajaxdata = $(".signup-form").serialize() + "&action=ajax_sign_up";
        $.post(ajaxurl, ajaxdata, function(res){
            $('.cta-res').html(res);
            $('.cta-res').show();
            if (!$(res).is('p')) {
                dataLayer.push({
                    'event': 'emailSuccessfullyRegistered'
                });
            }
            setTimeout(function(){
                $('.cta-res p').remove();
                btn.prop("disabled", false);
                $('.cta-res').hide();
            }, 3000);
            setTimeout(function(){
                $('.cta-newsletter-thanks').hide();
            }, 3000);
        });
        return false;
    });
    /* sign Up button js - ends here */
});



function subroomCarousel(){
    var initialSlide = 0; // Default start index if none is specified in URL
    if (window.location.hash && window.location.hash != '#designers') {
        initialSlide = parseInt(window.location.hash.slice(8));
    }
    var sliderFor = '.slick-slider-stage',
        sliderNav = '.slick-slider-nav',
        customSlide = $(sliderNav).find('.slick-slide'),
        draggableOption = (($(sliderFor).data('draggable') == false) ? false : true),
        firstItemSwipeOption = (($(sliderFor).data('first-item-swipe') == false) ? false : true),
        autoplaySpeedOption = (($(sliderFor).data('autoplay-speed')) ? $(sliderFor).data('autoplay-speed') : 9000);

    $(sliderFor).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: initialSlide,
        centerMode: false,
        adaptiveHeight: false,
        draggable: draggableOption,
        swipe: draggableOption,
        arrows: true,
        autoplay: true,
        autoplaySpeed: autoplaySpeedOption,
        prevArrow: '<a href="javascript:void(0)" class="slick-prev"><span></span></a>',
        nextArrow: '<a href="javascript:void(0)" class="slick-next"><span></span></a>',
    });

    //console.log(firstItemSwipeOption);
    if (!firstItemSwipeOption) {
        $('.carousel-stage.slick-slider .slick-prev').addClass('hide');
    }

    $(sliderFor).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.carousel-stage.slick-slider .slick-next span').addClass('animate-arrow');
        $('.carousel-stage.slick-slider .slick-prev span').addClass('animate-arrow');
        setTimeout(function(){
            $('.carousel-stage.slick-slider .slick-next span').removeClass('animate-arrow');
            $('.carousel-stage.slick-slider .slick-prev span').removeClass('animate-arrow');
        }, 1500);
    });


    if (!firstItemSwipeOption) {
        $(sliderFor).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            if (currentSlide == 0) {
                $('.carousel-stage.slick-slider .slick-prev').addClass('hide');
            } else {
                $('.carousel-stage.slick-slider .slick-prev').removeClass('hide');
            }
        });
    }
    $(sliderNav).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: initialSlide,
        centerMode: false,
        focusOnSelect: false,
        prevArrow: '<a href="javascript:void(0)" class="slick-prev"><span></span></a>',
        nextArrow: '<a href="javascript:void(0)" class="slick-next"><span></span></a>',
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });
    $(sliderNav).find('.slick-current').addClass('slick-goto');
    customSlide.on('click', function(){
        $(sliderFor).slick('slickGoTo', $(this).attr('data-slick-index'));
        customSlide.removeClass('slick-goto');
        $(this).addClass('slick-goto');
    });
}

function tabbedContentMoreLess(){
    var currentMoreState = 0;
    var moreText = $('.btn-more-text').text(),
        lessText = $('.btn-less-text').text(),
        readMoreHeight = $('.tabcontent-readmore').height(),
        readLessHeight = $('.tabcontent-readless').height();
    if (( readMoreHeight >= readLessHeight ) && ( readMoreHeight != 0 )) {
        // Sets the .more-block div to the specified height and hides any content that overflows
        $("a.btn-moreless").text(moreText);
        franchiseTabHeight();
        $(".btn-moreless").on('click tap', function() {
            if (currentMoreState == 0) {
                $(this).text(lessText);
                $('.custom-closet-tabs').find(".tabcontent-readless").css('display', 'none');
                $('.custom-closet-tabs').find(".tabcontent-readmore").css('display', 'block').css('height', 'auto').css('overflow', 'visible');
                $('.custom-closet-tabs').find('.btn-moreless').text(lessText);
                currentMoreState = 1;
                franchiseTabHeight();
            } else if (currentMoreState == 1) {
                $(this).text(moreText);
                $('.custom-closet-tabs').find(".tabcontent-readmore").css('display', 'none');
                $('.custom-closet-tabs').find(".tabcontent-readless").css('display', 'block');
                $('.custom-closet-tabs').find('.btn-moreless').text(moreText);
                currentMoreState = 0;
                franchiseTabHeight();
            }
        });
    }
}

function mobileTabbedContent(){
    $('.mobile-tabbed-content .accordion').on('click tap', function(){
        //console.log($(this));
        if($(this).hasClass('show_tab')){
            console.log('true');
            $('.mobile-tabbed-content .accordion.show_tab').each(function () {
                $(this).removeClass('show_tab');
            });
            $('body').scrollTo(0, $(this));
            return false;
        }else {
            console.log('false');
            $('.mobile-tabbed-content .accordion.show_tab').each(function () {
                $(this).removeClass('show_tab');
            });
            $(this).addClass('show_tab');
            $('body').scrollTo(0, $(this));
            return false;
        }
    });
}
function franchiseTabHeight(){
    
    var contentHeight = $('.custom-closet-tabs .tab .scroll-cont').height(),
            tabHeight = $('.custom-closet-tabs .tabs-menu ul').height();
    if ($(window).width() < 767) {
        //$('.custom-closet-tabs .tabs-menu ul').css('height', contentHeight);
        $('.custom-closet-tabs .tab .scroll-cont').css('min-height', tabHeight);
    }
    else {
        $('.custom-closet-tabs .tabs-menu ul').css('height', contentHeight + 50);
        //$('.tabs-menu').css('min-height', $('.custom-closet-tabs .tab .scroll-cont').height() + 50);
    }
}

//Press news page as seen as slider
$('.about-logo').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    items:5,
    autoplay:true,
    nav:true,
    dots:false,
    mouseDrag: false,
    touchDrag: true,
    autoplayTimeout:3000,
	responsive:{
        0:{
            items:2
        },
        600:{
            items:3
        },
        1000:{
            items:5
        }
    }
});


/* zoom in image for material details swatches start 
function imageZoom(){
	$('.img-show').popover({
		placement: function(context, source){
			var position = $(source).offset().top,
				hPosition = $(source).position();
			if ($(window).width() > 991) {
				if (position - $(window).scrollTop() > 340) {
					return "top";
				} else if (position - $(window).scrollTop() > 120 && hPosition.left > 415) {
					return "left";
				} else if (position - $(window).scrollTop() > 120 && hPosition.left < 415) {
					return "right";
				} else {
					return "bottom";
				}
			} else {
				if (position - $(window).scrollTop() > 340) {
					return 'top';
				} else {
					return "bottom";
				}
			}
		},
		trigger: 'focus hover',
		html: true,
		content: function(){
			return $(this).next('.img-content-preview').html();
		}
	});
	$('body')
		.on('click', function(e){
			$('.img-show').each(function(){
				//the 'is' for buttons that trigger popups
				//the 'has' for icons within a button that triggers a popup
				if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
					$(this).popover('hide');
				}
			});
		})
		.on('tap', function(e){
			$('.img-show').each(function(){
				//the 'is' for buttons that trigger popups
				//the 'has' for icons within a button that triggers a popup
				if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
					$(this).popover('hide');
				}
			});
		});
	$('.img-show').on('mouseenter', function(){
		$(this).parent().siblings().children('.img-show').popover('hide');
		$(this).popover('show');
	});
}*/

$(document).ready(function() {
    $(".room-select .visit-type").bind("click", function(a) {
        var b = $(this).find("input:checkbox");
        $(a.target).is("input:checkbox") ? $(b).is(":checked") ? $(this).addClass("checked") : $(this).removeClass("checked") : $(b).is(":checked") ? ($(this).find("input:checkbox").prop("checked", !1), $(this).removeClass("checked")) : ($(this).find("input:checkbox").prop("checked", !0), $(this).addClass("checked"))
    })

    $(".social-connect ul li a.facebook").on('click', function(ee){
    	ee.preventDefault();

    	//alert(project); 

    	var galleryTilte = $(this).attr('galleryTilte');
    	var summary = $(this).attr('summary');
    	var galimg = $(this).attr('galimg');
    	var url = $(this).attr('url')+'?project='+galno;

    	var galno = $(this).attr('rel');


    	//alert(galleryTilte+'--'+summary+'--'+url+'---'+galno+'---'+galimg);

    	$('meta[property="og:title"]').attr('content', galleryTilte );
    	$('meta[property="og:description"]').attr('content', summary);
    	$('meta[property="og:url"]').attr('content', url);
    	$('meta[property="og:image"]').attr('content', galimg);

        window.open("http://www.facebook.com/sharer.php?u=" + encodeURIComponent(currObjURL + "?sliding=1&project=" + galno), '_blank', 'height=600,width=800');
	});

	$('.btnPinIt').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        var url = encodeURIComponent($(this).attr('href'));
        var media = $(this).attr('data-image');
        var desc = $(this).attr('data-desc');
        window.open("//www.pinterest.com/pin/create/button/"+
        "?url="+url+
        "&media="+media+
        "&description="+desc,"_blank", 'width=700, height=300');
        return false;
    });
});